import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { useQrCodeLink } from '../../../../shared/hooks/linkHook';
import { useSignInRedirect } from '../../../../shared/hooks/oauthHook';
import { LayoutHeaderContextProvider } from '../Layout/LayoutHeader';
import { PreviewLayout } from '../Layout/PreviewLayout';
import {
  LinkPageBackground,
  LinkPageContainer,
  MessageComponent,
  MessageContent,
} from '../Preview/MessageComponents';

export const QrCodePrepare = () => {
  const { id: uri = '' } = useParams();

  const {
    data: qrCodeLink,
    isFetching,
    isError: isErrorQrCodeLink,
    error: errorQrCodeLink,
  } = useQrCodeLink(uri);
  const isQrExpired = qrCodeLink?.expiredTime
    ? +new Date(qrCodeLink.expiredTime) - +Date.now() < 0
    : false;
  const isNotFound = errorQrCodeLink?.response?.status === 404;

  const signInRedirect = useSignInRedirect();
  const onClickLoginButton = () => {
    signInRedirect({ redirect: `/qr/${uri}` });
  };
  const onClickSignUpButton = () => {
    signInRedirect({ register: true, redirect: `/qr/${uri}` });
  };

  return (
    <LayoutHeaderContextProvider
      onClickLoginButton={onClickLoginButton}
      onClickSignUpButton={onClickSignUpButton}>
      <PreviewLayout>
        <LinkPageBackground>
          <LinkPageContainer>
            {isFetching ? (
              <ProcessingQrMessage />
            ) : isNotFound ? (
              <QrNotFoundMessage />
            ) : isErrorQrCodeLink ? (
              <QrErrorMessage />
            ) : isQrExpired ? (
              <QrExpiredMessage />
            ) : (
              // TODO: focus case id
              <QrProcessedMessage />
            )}
          </LinkPageContainer>
        </LinkPageBackground>
      </PreviewLayout>
    </LayoutHeaderContextProvider>
  );
};

const ProcessingQrMessage = () => {
  return <CircularProgress size={60} />;
};

const QrNotFoundMessage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.qrCodePrepare.notFoundMessage',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
    </MessageComponent>
  );
};

const QrErrorMessage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.qrCodePrepare.errorMessage',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
    </MessageComponent>
  );
};

const QrExpiredMessage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.qrCodePrepare.expiredMessage',
  });

  return (
    <MessageComponent
      icon={<WarningAmberIcon sx={{ color: '#2e5be0', fontSize: '40px' }} />}
      title={t('title')}>
      <MessageContent>{t('content')}</MessageContent>
    </MessageComponent>
  );
};

const QrProcessedMessage = () => {
  const { id: uri = '' } = useParams();
  useEffect(() => {
    if (uri) {
      window.location.replace(`/qr/${uri}/preview`);
    }
  }, [uri]);

  return <></>;
};
